import React from 'react';
import { Box, Divider } from '@mui/material';
import StandardizedChip from '../../../common/StandardizedChip';
import VersionHeaderCard from './VersionHeaderCard';
import ExecutionStatisticsCard from './ExecutionStatisticsCard';
import CostAnalysisCard from './CostAnalysisCard';
import FeedbackMetricsCard from './FeedbackMetricsCard';
import ContentCheckResultsCard from './ContentCheckResultsCard';
import VersionTimelineCard from './VersionTimelineCard';

/**
 * VersionDetailsSection Component
 *
 * Displays detailed analytics for a selected version.
 *
 * @param {Object} props
 * @param {Object} props.selectedVersion - Selected version analytics data
 */
function VersionDetailsSection({ selectedVersion }) {
  if (!selectedVersion) {
    return null;
  }

  return (
    <Box>
      {/* Visual Separator */}
      <Divider sx={{ my: 4, borderWidth: 2, borderColor: 'divider' }}>
        <StandardizedChip
          label="Version Details"
          color="primary"
          width={120}
          height={32}
          sx={{ px: 2, py: 1, fontSize: '0.875rem', fontWeight: 600 }}
        />
      </Divider>

      <VersionHeaderCard selectedVersion={selectedVersion} />
      <ExecutionStatisticsCard selectedVersion={selectedVersion} />
      <CostAnalysisCard selectedVersion={selectedVersion} />
      <FeedbackMetricsCard selectedVersion={selectedVersion} />
      <ContentCheckResultsCard selectedVersion={selectedVersion} />
      <VersionTimelineCard selectedVersion={selectedVersion} />
    </Box>
  );
}

export default VersionDetailsSection;
